import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import React, { useCallback, useEffect, useState } from 'react';

import { setLightningRemind } from '@/api/mkt';
import Toast, { showToast, removeToast } from '@/components/common/Toast';
import { getLoginState } from '@/utils/common/user';
import { WeeeIcon } from '@/components/common/Icon';
import NotifyAdd from './notify-add';

type ReminderProp = Partial<{
  id?: number;
  isReminded?: boolean;
  className?: string;
  render;
}> & {
  // Tips: mkpl 秒杀landing页会展示多日期的秒杀商品，因此remaind me需要传日期
  date: string;
};

function getSubStr(str: string) {
  if (str?.length >= 15) {
    let subStr1 = str.substr(0, 6);
    let subStr2 = str.substr(str.length - 5, 5);
    let subStr = subStr1 + '...' + subStr2;
    return subStr;
  }
  return str;
}

const Reminder = ({ id, isReminded, className, date }: ReminderProp) => {
  const { t, lang } = useTranslation('common');
  const [reminded, setReminded] = useState<boolean>(isReminded || false);

  const toggleCollect = useCallback(
    (isCancel: boolean, newRemind?: boolean) => {
      if (!id || !date) {
        console.error('id or date is required: id:', id, 'date:', date);
        return;
      }
      const status = newRemind !== undefined ? newRemind : reminded;
      setLightningRemind({
        product_id: id,
        status: status ? 'X' : 'A',
        date: date || undefined
      })
        .then(res => {
          if (res?.result) {
            setReminded(!status);

            if (isCancel) {
              return removeToast();
            }
            if (!status) {
              showToast(
                <NotifyAdd
                  getLangMsg={() => t('has_add_notify_after_3_min')}
                  getBtn={() => t('notify_cancel')}
                  onCancel={() => toggleCollect(true, !reminded)}
                />,
                4000
              );
            }
          } else {
            Toast.info(res?.message);
          }
        })
        .catch(e => {
          Toast.info(e?.message);
        });
    },
    [id, date, reminded, t]
  );

  useEffect(() => {
    setReminded(isReminded);
  }, [isReminded]);

  const defaultNode = (
    <button
      // inline={true}
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        if (!getLoginState()) {
          window.location.href = `/${lang}/account/login?redirect_url=${encodeURIComponent(window.location.href)}`;
          return;
        }
        toggleCollect(false);
      }}
      data-role="remind-btn"
      className={classNames(
        'product-card-btn-shadow py-[5px] pl-[5px] pr-2.5 bg-surface-100-bg rounded-[21px] absolute right-0 bottom-0 z-[2]',
        className
      )}>
      {reminded ? (
        <span className="text-highlight-txt font-medium flex items-center justify-center leading-[14px]">
          <WeeeIcon style={{ fontSize: 12 }} className="mr-[5px] relative top-[1px]" type="iconcheck-thin" />
          {getSubStr(t('lightning_reminded'))}
        </span>
      ) : (
        <span className="text-surface-100-fg-default font-medium flex items-center justify-center leading-[14px]">
          <WeeeIcon className="mr-[5px]" style={{ fontSize: 14 }} type="iconclock" />
          {t('lightning_remind')}
        </span>
      )}
    </button>
  );
  return defaultNode;
};

const LightningReminder = props => {
  const { data, className, date } = props;

  return <Reminder id={data?.id} className={className} isReminded={data?.remind_set} date={date} />;
};

export default React.memo(LightningReminder);
